module.exports = __webpack_public_path__ + "img/668.c20e4ebb.png";